export default "__VITE_ASSET__CdR6B1GC__"